import React from "react";

const OxygenLevelIcon = () => {
  return (
    <svg
      width="19"
      height="21"
      viewBox="0 0 19 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.88227 18.7288C9.66051 18.7288 9.47201 18.6377 9.31678 18.4554C9.16155 18.2731 9.08393 18.0518 9.08393 17.7913V13.6247C9.08393 13.3643 9.16155 13.1429 9.31678 12.9606C9.47201 12.7783 9.66051 12.6872 9.88227 12.6872H12.0999C12.3217 12.6872 12.5101 12.7783 12.6654 12.9606C12.8206 13.1429 12.8982 13.3643 12.8982 13.6247V17.7913C12.8982 18.0518 12.8206 18.2731 12.6654 18.4554C12.5101 18.6377 12.3217 18.7288 12.0999 18.7288H9.88227ZM10.2371 17.3747H11.7451V14.0413H10.2371V17.3747ZM14.2288 20.9163V18.0518C14.2288 17.7798 14.304 17.5555 14.4543 17.379C14.6046 17.2025 14.7955 17.1143 15.0271 17.1143H17.0674V16.0205H14.2288V14.6663H17.4222C17.6538 14.6663 17.8448 14.7546 17.9951 14.9311C18.1454 15.1076 18.2205 15.3318 18.2205 15.6038V17.5309C18.2205 17.8029 18.1454 18.0272 17.9951 18.2037C17.8448 18.3802 17.6538 18.4684 17.4222 18.4684H15.382V19.5622H18.2205V20.9163H14.2288ZM7.42812 20.8816C5.53082 20.708 3.97232 19.8212 2.75263 18.221C1.53294 16.6209 0.923096 14.6721 0.923096 12.3747C0.923096 10.6386 1.51076 8.75054 2.6861 6.71061C3.86144 4.67068 5.63923 2.46148 8.01947 0.0830078C9.99069 2.0506 11.564 3.93717 12.7393 5.74272C13.9146 7.5483 14.6526 9.21497 14.9532 10.7427H8.90652C8.49749 10.7427 8.14884 10.912 7.86056 11.2505C7.57227 11.5891 7.42812 11.9985 7.42812 12.4788V20.8816Z"
        fill="#F2994A"
      />
    </svg>
  );
};

export default OxygenLevelIcon;
